import TableCell from '@mui/material/TableCell';
import { FC, useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import styles from './styles.module.css';

interface CellProps {
  price: string;
  onChange: (value: string) => void;
}

export const Cell: FC<CellProps> = ({price, onChange}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isEdit, setIsEdit] = useState(false);
  const editMode = () => setIsEdit(true);
  const onChangeHdl = (value: string) => {
    onChange(value)
  }
  const handleBlur = () => {
    if(Number.isNaN(price) || Number(price) < 0)  onChange('0')
    setIsEdit(false);
  };

  useEffect(() => {
    if (isEdit && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEdit]);

  return <TableCell
    className={styles.cell}
    onClick={editMode}
    align="left">
    {isEdit ?
      <TextField
        inputRef={inputRef}
        type="number"
        onBlur={handleBlur}
        onChange={(e) => onChangeHdl(e.target.value)}
        className={styles.textField}
        fullWidth
        value={price}
        hiddenLabel={true} /> : price}
  </TableCell>
}